import { currentEnv } from "./env.ts";

export const ENVS = {
	localhost: {
		VITE_ENV: "dev",
		VITE_APP_URL: "*.dev-app.konfhub.com",
		VITE_API_URL: " https://dev-api.konfhub.com",
		VITE_APP_BUCKET_NAME: "kh-attendee-app-dev",
		VITE_CENTRAL_LOGIN_URL: "https://dev-accounts.konfhub.com",
		VITE_AWS_PROJECT_REGION: "ap-southeast-1",
		VITE_AWS_COGNITO_IDENTITY_POOL_ID: "ap-southeast-1:9a5331da-329a-497d-be61-15668b42bf8f",
		VITE_AWS_COGNITO_REGION: "ap-southeast-1",
		VITE_AWS_USER_POOLS_ID: "ap-southeast-1_f6tfrmIsS",
		VITE_OAUTH_DOMAIN: "dev-auth.konfhub.com",
		VITE_AWS_USER_POOLS_WEB_CLIENT_ID: "1cum79568pe0u434ek1d5kin9a",
		VITE_AWS_APPSYNC_GRAPHQLENDPOINT: "https://dev-attendee-api.konfhub.com/graphql",
		VITE_HOST_NAME: "localhost",
		VITE_SENTRY_AUTH_TOKEN:
			"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",
		VITE_GRAPHQL_PUBLIC_API_KEY: "da2-r3oju7njvrbhhed2egv3nel6jy",
		VITE_EVENT_ID: "c04761fb-dff2-417d-9c65-31198faf925b",
		VITE_X_API_KEY: "c8e680f8-30c3-4bc4-8e91-1c3ba5fc2a77"
	},
	dev: {
		VITE_ENV: "dev",
		VITE_APP_URL: "*.dev-app.konfhub.com",
		VITE_API_URL: "https://dev-api.konfhub.com",
		VITE_APP_BUCKET_NAME: "kh-attendee-app-dev",
		VITE_CENTRAL_LOGIN_URL: "https://dev-accounts.konfhub.com",
		VITE_AWS_PROJECT_REGION: "ap-southeast-1",
		VITE_AWS_COGNITO_IDENTITY_POOL_ID: "ap-southeast-1:9a5331da-329a-497d-be61-15668b42bf8f",
		VITE_AWS_COGNITO_REGION: "ap-southeast-1",
		VITE_AWS_USER_POOLS_ID: "ap-southeast-1_f6tfrmIsS",
		VITE_OAUTH_DOMAIN: "dev-auth.konfhub.com",
		VITE_AWS_USER_POOLS_WEB_CLIENT_ID: "1cum79568pe0u434ek1d5kin9a",
		VITE_AWS_APPSYNC_GRAPHQLENDPOINT: "https://dev-attendee-api.konfhub.com/graphql",
		VITE_HOST_NAME: "konfhub.com",
		VITE_SENTRY_AUTH_TOKEN:
			"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",
		VITE_GRAPHQL_PUBLIC_API_KEY: "da2-r3oju7njvrbhhed2egv3nel6jy",
		VITE_EVENT_ID: "c04761fb-dff2-417d-9c65-31198faf925b",
		VITE_X_API_KEY: "c8e680f8-30c3-4bc4-8e91-1c3ba5fc2a77"
	},
	"pre-prod": {
		VITE_ENV: "pre-prod",
		VITE_APP_URL: "*.pre-prod-app.konfhub.me",
		VITE_API_URL: "https://pre-prod-api.konfhub.me",
		VITE_APP_BUCKET_NAME: "kh-attendee-app-pre-prod",
		VITE_CENTRAL_LOGIN_URL: "https://pre-prod-accounts.konfhub.me",
		VITE_AWS_PROJECT_REGION: "us-east-2",
		VITE_AWS_COGNITO_IDENTITY_POOL_ID: "us-east-2:663b7319-9305-48f7-aa41-dfbacf0e346b",
		VITE_AWS_COGNITO_REGION: "us-east-2",
		VITE_AWS_USER_POOLS_ID: "us-east-2_uJK6um78b",
		VITE_OAUTH_DOMAIN: "pre-prod-auth.konfhub.me",
		VITE_AWS_USER_POOLS_WEB_CLIENT_ID: "77bohmtvsrngh0kc7nqqblitvv",
		VITE_AWS_APPSYNC_GRAPHQLENDPOINT: "https://pre-prod-attendee-api.konfhub.me/graphql",
		VITE_HOST_NAME: "konfhub.me",
		VITE_SENTRY_AUTH_TOKEN:
			"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",
		VITE_GRAPHQL_PUBLIC_API_KEY: "da2-r3oju7njvrbhhed2egv3nel6jy",
		VITE_EVENT_ID: "c04761fb-dff2-417d-9c65-31198faf925b",
		VITE_X_API_KEY: "f47ac10b-58cc-4372-a567-0e02b2c3d479"
	},
	staging: {
		VITE_ENV: "staging",
		VITE_APP_URL: "*.staging-app.konfhub.com",
		VITE_API_URL: "https://staging-api.konfhub.com",
		VITE_APP_BUCKET_NAME: "kh-attendee-app-staging",
		VITE_CENTRAL_LOGIN_URL: "https://staging-accounts.konfhub.com",
		VITE_AWS_PROJECT_REGION: "us-east-1",
		VITE_AWS_COGNITO_IDENTITY_POOL_ID: "us-east-1:337d5ba7-28cf-4e5a-b991-6c66fdfa215d",
		VITE_AWS_COGNITO_REGION: "us-east-1",
		VITE_AWS_USER_POOLS_ID: "us-east-1_Qt5m915Di",
		VITE_OAUTH_DOMAIN: "kh-staging-auth.konfhub.com",
		VITE_AWS_USER_POOLS_WEB_CLIENT_ID: "11h7864bll3sgmtb93qb5coeg3",
		VITE_AWS_APPSYNC_GRAPHQLENDPOINT: "https://staging-attendee-api.konfhub.com/graphql",
		VITE_HOST_NAME: "konfhub.com",
		VITE_SENTRY_AUTH_TOKEN:
			"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",
		VITE_GRAPHQL_PUBLIC_API_KEY: "da2-np4ggmvkvvaqpapn73xvm2lchq",
		VITE_EVENT_ID: "c2ae576a-7a6e-48f6-89c2-2a672a82e943",
		VITE_X_API_KEY: "15533343-74c6-4970-a63e-f87edffabbeb"
	},
	prod: {
		VITE_ENV: "prod",
		VITE_APP_URL: "*.app.konfhub.com",
		VITE_API_URL: "https://api.konfhub.com",
		VITE_APP_BUCKET_NAME: "kh-attendee-app-prod",
		VITE_CENTRAL_LOGIN_URL: "https://accounts.konfhub.com",
		VITE_AWS_PROJECT_REGION: "ap-south-1",
		VITE_AWS_COGNITO_IDENTITY_POOL_ID: "ap-south-1:0bf02d86-5b7b-4665-964d-cb52f756903b",
		VITE_AWS_COGNITO_REGION: "ap-south-1",
		VITE_AWS_USER_POOLS_ID: "ap-south-1_acJo3XGbL",
		VITE_OAUTH_DOMAIN: "auth.konfhub.com",
		VITE_AWS_USER_POOLS_WEB_CLIENT_ID: "5jf10rk2c0muftotp1iu2ucup0",
		VITE_AWS_APPSYNC_GRAPHQLENDPOINT: "https://attendee-api.konfhub.com/graphql",
		VITE_HOST_NAME: "konfhub.com",
		VITE_SENTRY_AUTH_TOKEN:
			"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",
		VITE_GRAPHQL_PUBLIC_API_KEY: "da2-5uz4kjc3z5gj7gspqffvtcwuyq",
		VITE_EVENT_ID: "03cba435-7384-4148-992e-e5e4937fd333",
		VITE_X_API_KEY: "f0dc80af-4e32-480b-a5c3-fe97a7baf8d6"
	},
	"prod-d": {
		VITE_ENV: "prod-d",
		VITE_APP_URL: "aibooth-prod-d-app.konfhub.me",
		VITE_API_URL: "https://prod-d-api.konfhub.me",
		VITE_APP_BUCKET_NAME: "kh-attendee-app-prod-d",
		VITE_CENTRAL_LOGIN_URL: "https://prod-d-accounts.konfhub.me",
		VITE_AWS_PROJECT_REGION: "me-central-1",
		VITE_AWS_COGNITO_IDENTITY_POOL_ID: "me-central-1:0bf02d86-5b7b-4665-964d-cb52f756903b",
		VITE_AWS_COGNITO_REGION: "me-central-1",
		VITE_AWS_USER_POOLS_ID: "me-central-1_acJo3XGbL",
		VITE_OAUTH_DOMAIN: "prod-d-auth.konfhub.me",
		VITE_AWS_USER_POOLS_WEB_CLIENT_ID: "5jf10rk2c0muftotp1iu2ucup0",
		VITE_AWS_APPSYNC_GRAPHQLENDPOINT: "https://prod-d-attendee-api.konfhub.me/graphql",
		VITE_HOST_NAME: "konfhub.me",
		VITE_SENTRY_AUTH_TOKEN:
			"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",
		VITE_GRAPHQL_PUBLIC_API_KEY: "da2-r3oju7njvrbhhed2egv3nel6jy",
		VITE_EVENT_ID: "c04761fb-dff2-417d-9c65-31198faf925b",
		VITE_X_API_KEY: "c8e680f8-30c3-4bc4-8e91-1c3ba5fc2a77"
	},
	custom: {
		VITE_ENV: "prod",
		VITE_APP_URL: "*.app.konfhub.com",
		VITE_API_URL: "https://api.konfhub.com",
		VITE_APP_BUCKET_NAME: "kh-attendee-app-prod",
		VITE_CENTRAL_LOGIN_URL: "https://accounts.konfhub.com",
		VITE_AWS_PROJECT_REGION: "ap-south-1",
		VITE_AWS_COGNITO_IDENTITY_POOL_ID: "ap-south-1:0bf02d86-5b7b-4665-964d-cb52f756903b",
		VITE_AWS_COGNITO_REGION: "ap-south-1",
		VITE_AWS_USER_POOLS_ID: "ap-south-1_acJo3XGbL",
		VITE_OAUTH_DOMAIN: "auth.konfhub.com",
		VITE_AWS_USER_POOLS_WEB_CLIENT_ID: "5jf10rk2c0muftotp1iu2ucup0",
		VITE_AWS_APPSYNC_GRAPHQLENDPOINT: "https://attendee-api.konfhub.com/graphql",
		VITE_HOST_NAME: "futuresustainabilityforum.com",
		VITE_SENTRY_AUTH_TOKEN:
			"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",
		VITE_GRAPHQL_PUBLIC_API_KEY: "da2-5uz4kjc3z5gj7gspqffvtcwuyq",
		VITE_EVENT_ID: "03cba435-7384-4148-992e-e5e4937fd333",
		VITE_X_API_KEY: "f0dc80af-4e32-480b-a5c3-fe97a7baf8d6"
	}
};

const getEnvName = () => {
	// 1. Check if VITE_ENV is explicitly set in the build environment
	const injectedEnv = (typeof process !== "undefined" ? process.env.VITE_ENV : (import.meta as any).env?.VITE_ENV) as string;
	if (injectedEnv && ENVS[injectedEnv as keyof typeof ENVS]) {
		return injectedEnv as any;
	}

	// 2. Runtime hostname detection
	if (typeof window !== "undefined") {
		const hostname = window?.location?.hostname || "localhost";

		if (hostname.includes("aibooth-dev.konfhub.com") || hostname.includes("localhost")) {
			return "dev";
		}
		if (hostname.includes(".staging-app.konfhub.com") || hostname === "staging-app.konfhub.com") {
			return "staging";
		}
		if (hostname.includes("pre-prod-app.konfhub.me") || hostname.includes("aibooth-pre-prod.konfhub.me")) {
			return "pre-prod";
		}
		if (hostname.includes("prod-d-app.konfhub.me") || hostname.includes("aibooth-prod-d-app.konfhub.me")) {
			return "prod-d";
		}
		if (hostname.includes(".app.konfhub.com") || hostname === "app.konfhub.com") {
			return "prod";
		}

		// Check for custom domains or fall back to prod
		return "prod";
	}

	return currentEnv;
};

export const ENV_NAME = getEnvName();
export const isKHDomain = getEnvName() !== "custom";
